//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/ScCollector.js";
import "../GeometricUtilities/GeometricUtilities.FaceChangeOverflowBehavior.js";
import "../no/SelectISurface.js";
import "../no/GeometricUtilities.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"Face",0,"ScCollector",0],[1,"FaceChangeOverflowBehavior",0,"GeometricUtilities.FaceChangeOverflowBehavior",0],[0,"IncludeBlends",1,0],[0,"IncludeHoles",1,0],[1,"Plane",0,"SelectISurface",0],[0,"SectionSketch",1,"Sketch",0]],[[[],"CreateSectionCurve",{},0,0],[[],"RecreateSectionCurve",{},0,0],[[],"ChangeSectionCurve",{},0,0],[[],"IncludeBlendFaces",{},0,0],[[],"IncludeHoleFaces",{},0,0],[[],"RemoveData",{},0,0],[["sectionSketch"],"DeleteSectionSketch",{},1,0]],[]];
SPLM.Features.EditCrossSectionBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.EditCrossSectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;